import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star", "label", "feedback"]
  static values = {
    url: String,
    questionId: Number,
    participationId: Number,
    currentRating: Number,
    responseId: String
  }

  connect() {
    this.updateStars(this.currentRatingValue)
  }

  async rate(event) {
    const rating = parseInt(event.currentTarget.dataset.rating)

    this.updateStars(rating)

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const isUpdate = this.responseIdValue && this.responseIdValue !== ''
    const url = isUpdate
      ? `${this.urlValue}/${this.responseIdValue}`
      : this.urlValue
    const method = isUpdate ? 'PATCH' : 'POST'

    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          assessment_response: {
            assessment_question_id: this.questionIdValue,
            rating: rating
          }
        })
      })

      if (response.ok) {
        const data = await response.json()
        this.currentRatingValue = rating

        if (!isUpdate && data.response_id) {
          this.responseIdValue = data.response_id
        }

        this.showFeedback()
        this.updateProgressBar(data.progress_percentage)
      } else {
        console.error('Failed to save rating')
      }
    } catch (error) {
      console.error('Error saving rating:', error)
    }
  }

  updateProgressBar(percentage) {
    const progressBar = document.querySelector('[data-controller="progress-bar"]')
    if (progressBar) {
      progressBar.style.width = `${percentage}%`
    }

    const progressText = document.querySelector('[data-progress-text]')
    if (progressText) {
      progressText.textContent = `${percentage}%`
    }
  }

  updateStars(rating) {
    this.starTargets.forEach((star, index) => {
      const svg = star.querySelector('svg')
      if (index < rating) {
        svg.classList.remove('text-gray-300')
        svg.classList.add('text-yellow-400')
      } else {
        svg.classList.remove('text-yellow-400')
        svg.classList.add('text-gray-300')
      }
    })

    if (this.hasLabelTarget) {
      const labels = ['one', 'two', 'three', 'four', 'five']
      const labelKey = labels[rating - 1]
      this.labelTarget.textContent = this.labelTarget.dataset[labelKey] || `${rating}/5`
    }
  }

  showFeedback() {
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.classList.remove('hidden')
      setTimeout(() => {
        this.feedbackTarget.classList.add('hidden')
      }, 2000)
    }
  }
}
